
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AlertService } from '../alert/alert.service';
import { ProfileService } from '../profile/profile.service';
import { AuthService } from '../auth/auth.service';
import { PROFILE_TYPE } from 'src/app/constants';
import { ProfessionalSubscription } from 'src/app/models/profile';

@Injectable()
export class CarryPageGuard implements CanActivate {

  
  constructor(
    protected auth: AuthService,
    protected alert: AlertService,
    protected profile: ProfileService,
    protected router: Router,
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    try {
      const loggedIn = await this.auth.isLoggedIn();
      if (!loggedIn) {
        return true;
      }

      const user = await this.profile.getProfile();
      const { type = '', professionalSubscription = {} as ProfessionalSubscription } = user;
      const { active = false } = professionalSubscription || {};

      if (user && user.type === PROFILE_TYPE.company) {
        await this.alert.translate('GUARD_COMPANY');
        return false;
      }

      if (type === PROFILE_TYPE.professional && !active) {
        this.alert.confirm({
          messageKey: 'GUARD_PROFESSIONAL',
          okTextKey: 'BECOME_CARRIER',
          okHandler: () => this.router.navigate(['/profile'], { fragment: '2', replaceUrl: true }),
        });
  
        return false;
      }

      return true;

    } catch (err) {
      return true;
    }

  }
}
